import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typeahead,
  Menu,
  MenuItem,
  withAsync,
  Highlighter,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "./../../axios";

import defaultProfileIcon from "./../../assets/images/profile-icon.png";

const AsyncTypeahead = withAsync(Typeahead);

const CandidateSearchBar = (props) => {
  const {
    defaultSelected,
    organization,
    multiple = false,
    handleSelection,
    selectedCandidates,
    placeholder,
  } = props;

  console.log("org :- ", organization);

  const orgId = organization ? organization._id : null;

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!defaultSelected) return;
    const newSelected = JSON.stringify(defaultSelected);
    const oldSelected = JSON.stringify(selectedUsers);
    console.log(defaultSelected);
    if (newSelected !== oldSelected) {
      if (Array.isArray(defaultSelected)) setSelectedUsers(defaultSelected);
      else setSelectedUsers([defaultSelected]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelected]);

  const _innerHandleSelection = (value) => {
    if (handleSelection) handleSelection(value);
    setSelectedUsers(value);
  };

  const onSearch = (query) => {
    setQuery(query);
    setLoading(true);
    Axios.get(`/api/orgAdmin/search-candidates?query=${query}`)
      .then((res) => {
        //destructure data
        const { result } = res.data;
        console.log(result);
        setOptions(result);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  return (
    <AsyncTypeahead
      id="my-typeahead-id"
      isLoading={loading}
      labelKey={(option) => `${option.firstName} ${option.lastName}`}
      onSearch={onSearch}
      onChange={_innerHandleSelection}
      placeholder={
        placeholder || "Search Candidate using first name or last name"
      }
      searchText="Searching, please wait..."
      useCache={true}
      selected={selectedUsers}
      options={options}
      multiple={multiple}
      renderMenu={(results, menuProps) => renderMenu(results, menuProps, query)}
      filterBy={() => true}
      delay={200}
    />
  );
};

const renderMenu = (results, menuProps, query = "") => {
  return (
    <Menu {...menuProps}>
      {results &&
        results.map((result, idx) => {
          const { firstName, lastName, profilePicUrl } = result;
          return (
            <MenuItem key={idx} option={result} position={idx}>
              <figure key="logo" style={{ float: "left", marginRight: "10px" }}>
                <img
                  src={profilePicUrl || defaultProfileIcon}
                  style={{ maxWidth: "40px", maxHeight: "40px" }}
                  alt="user logo"
                />
              </figure>
              <Highlighter search={query}>
                {`${firstName} ${lastName}`}
              </Highlighter>
            </MenuItem>
          );
        })}
    </Menu>
  );
};

export default CandidateSearchBar;
